export default __webpack_public_path__ + "static/media/icon_user-full.9ab2390b.svg";